<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <input
      :value="value"
      @input="updateValue($event.target.value)"
      type="email"
      :disabled="disabled"
      :placeholder="placeholder"
      :id="fieldId"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeEmail",

  mixins: [inputTypeMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeEmail.vue